import { genericMemo } from '../../utils/memo';
export const Show = genericMemo(function ShowImpl(props) {
    const { when, fallback, children } = props;
    if (when != null && when !== false) {
        if (typeof children === 'function') {
            return children(when);
        }
        return children;
    }
    if (fallback) {
        return fallback;
    }
    return null;
});
export const Hide = genericMemo(function Hide(props) {
    const { when, children } = props;
    if (when) {
        return null;
    }
    return children;
});
